var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic2-wrapper",style:(_vm.defaultStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }